import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MailerLayout from "./mailer/MailerLayout";
import MailerTemplate from "./mailer/MailerTemplate";
import MailerReports from "./mailer/MailerReports";
import MailerLogs from "./mailer/MailerLogs";

const Mailer: React.FC = () => {
  return (
    <Routes>
      <Route path="/*" element={<MailerLayout />}>
        <Route index element={<Navigate to="template" replace />} />
        <Route path="template" element={<MailerTemplate />} />
        <Route path="reports" element={<MailerReports />} />
        <Route path="logs" element={<MailerLogs />} />
      </Route>
    </Routes>
  );
};

export default Mailer;
